import s from "./english-docks.module.css";

function EnglishDocks() {
    return (
        <div className={s.englishDocks}>Ships cost -10%</div>
    )
}

export default EnglishDocks;
